import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { WebService } from './shared/services/web.service';
import { MetaDataService } from './shared/services/metadata.service';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ResourceService {
  resourcesList: any = [];

  constructor(private webapi: WebService, private metadata: MetaDataService) {}
  //   private resourcesList : any = [
  //     {
  //         id: 1,
  //         categoryId: 101,
  //         category: 'Commercial',
  //         name: 'Commercial Folder',
  //         avatar: 'assets/images/avatars/thumb-1.jpg',
  //         size: '12mb',
  //         popularity: 'high',
  //         assignment: 'Sales Irvine Santa Data',
  //         uploaded: '05/28/19',
  //         expires: '06/28/19',
  //         tag: 'Res',
  //         checked: false,
  //         type: 'folder',
  //     },
  //     {
  //         id: 2,
  //         categoryId: 101,
  //         category: 'Commercial',
  //         name: 'Commercial file',
  //         avatar: 'assets/images/avatars/thumb-1.jpg',
  //         size: '12mb',
  //         popularity: 'high',
  //         assignment: 'Sales Irvine Santa Data',
  //         uploaded: '05/28/19',
  //         expires: '06/28/19',
  //         tag: 'Res',
  //         checked: false,
  //         type: 'pdf',
  //         path: 'assets/files/pdf-sample.pdf#toolbar=0',
  //         user: 'Ryan Smith',
  //         status: 'Active'
  //     },
  //     {
  //         id: 3,
  //         categoryId: 102,
  //         category: 'Residential',
  //         name: 'Residential Folder',
  //         avatar: 'assets/images/avatars/thumb-2.jpg',
  //         size: '12mb',
  //         popularity: 'high',
  //         assignment: 'Sales Irvine Santa Data',
  //         uploaded: '05/28/19',
  //         expires: '06/28/19',
  //         tag: 'Res',
  //         checked: false,
  //         type: 'folder',
  //         status: 'Active'
  //     },
  //     {
  //         id: 4,
  //         categoryId: 102,
  //         category: 'Residential',
  //         name: 'Residential File',
  //         avatar: 'assets/images/avatars/thumb-3.jpg',
  //         size: '12mb',
  //         popularity: 'high',
  //         assignment: 'Sales Irvine Santa Data',
  //         uploaded: '05/28/19',
  //         expires: '06/28/19',
  //         tag: 'Res',
  //         checked: false,
  //         type: 'pdf',
  //         path: 'assets/files/pdf-sample.pdf#toolbar=0',
  //         status: 'Active'
  //     },
  //     {
  //         id: 5,
  //         name: 'NY Property Management',
  //         avatar: 'assets/images/avatars/thumb-4.jpg',
  //         size: '12mb',
  //         popularity: 'high',
  //         assignment: 'Sales Irvine Santa Data',
  //         uploaded: '05/28/19',
  //         expires: '06/28/19',
  //         tag: 'Res',
  //         checked: false,
  //         type: 'pdf',
  //         path: 'assets/files/pdf-sample.pdf#toolbar=0',
  //         status: 'Active'
  //     },
  //     {
  //         id: 7,
  //         name: 'Jack & Haros',
  //         avatar: 'assets/images/avatars/thumb-5.jpg',
  //         size: '12mb',
  //         popularity: 'high',
  //         assignment: 'Sales Irvine Santa Data',
  //         uploaded: '05/28/19',
  //         expires: '06/28/19',
  //         tag: ['Res'],
  //         checked: false,
  //         type: 'pdf',
  //         path: 'assets/files/pdf-sample.pdf#toolbar=0',
  //         status: 'Active'
  //     },
  //     {
  //         id: 8,
  //         name: 'Jack & Haros',
  //         avatar: 'assets/images/avatars/thumb-5.jpg',
  //         size: '12mb',
  //         popularity: 'high',
  //         assignment: 'Sales Irvine Santa Data',
  //         uploaded: '05/28/19',
  //         expires: '06/28/19',
  //         tag: ['Res'],
  //         checked: false,
  //         type: 'pdf',
  //         path: 'assets/files/pdf-sample.pdf#toolbar=0',
  //         status: 'Active'
  //     },
  // ]

  // getResources() {
  //   return new Promise((resolve, reject) => {
  //     let httpOptions = {
  //       headers: new HttpHeaders({
  //         'Content-Type': 'text/plain',
  //         'Access-Control-Allow-Origin': '*',
  //       }),
  //       observe: 'response' as 'body',
  //       responseType: 'text' as 'json',
  //     };
  //     this.webapi.requestJson('getResource', httpOptions).subscribe(
  //       (data) => {

  //         let response = JSON.parse(data.body);
  //         this.resourcesList = [...response.data];
  //         resolve(true);
  //       },
  //       (error) => {
  //         return true;
  //       }
  //     );
  //   });
  // }

  // getResourceRecordsById(id: number): Observable<any> {
  //   const resource = this.resourcesList.find((r) => r.resource_id === id);
  //   return of (resource);
  // }

  async getResources(params?: any) {
    try {
      let httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'text/plain',
          'Access-Control-Allow-Origin': '*',
        }),
        observe: 'response' as 'body',
        responseType: 'text' as 'json',
      };

      const response = await this.webapi
        .requestJson('getResource', httpOptions)
        .toPromise();
      const responseData = JSON.parse(response.body);
      this.resourcesList = [...responseData.data];

      return true;
    } catch (error) {
      throw error;
    }
  }

  async getResourceRecordsById(id: number): Promise<any> {
    try {
      await this.getResources();
      const resource = this.resourcesList.find((r) => r.resource_id === id);
      return resource;
    } catch (error) {
      console.error('Error fetching resources:', error);
      // Handle the error or throw it if necessary
      throw error;
    }
    // }
  }

  // getResources(): Observable<any> {
  //   return this.resourcesList
  // }

  // filterDataByRootFolder(rootFolder: any): void {
  //   this.selectedRootFolder = rootFolder;
  //   if (rootFolder) {
  //     this.filteredData = this.rootFoldersAndFiles.filter(item => item.parent_folder === rootFolder.resource_id);
  //   } else {
  //     this.filteredData = this.rootFoldersAndFiles;
  //   }
  // }

  // ngOnInit(): void {
  //   this.dataService.getData().subscribe(data => {
  //     this.rootFoldersAndFiles = this.buildResourceHierarchy(data);
  //     this.filteredFiles = this.rootFoldersAndFiles.filter(item => !item.is_folder);
  //   });
  // }

  // Function to handle root folder click and display files under the selected folder
  // displayFiles(selectedFolder: any): void {
  //   if (selectedFolder.is_folder) {
  //     // Filter and display files under the selected folder
  //     this.filteredFiles = selectedFolder.children.filter(item => !item.is_folder);
  //     this.selectedRootFolder = selectedFolder;
  //   } else {
  //     // Handle non-folder item (e.g., navigate to resource details)
  //     this.resourceService.getResourceRecordsById(selectedFolder.resource_id).subscribe(
  //       (records) => {
  //         this.router.navigate(['/resources', selectedFolder.resource_id]);
  //       }
  //     );
  //   }
  // }
}
